import ProgressIndicator from '@/components/progressIndicator';
import { useUserContext } from '@/contexts/userContext';
import { ReactNode } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

type Props = { children: ReactNode };

const ProtectedRoute = ({ children, ...rest }: Props) => {
  const userContext = useUserContext();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const appId = searchParams.get('appId');

  if (userContext.isLoading && !userContext?.user) {
    return <ProgressIndicator />;
  }

  if (!userContext?.user) {
    const redirectUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={appId ? `/login?appId=${appId}&redirect=${redirectUrl}` : `/login?redirect=${redirectUrl}`} />;
  }

  return children;
};

export default ProtectedRoute;
